import axios from "axios";
import Button from "components/Button";
import Content from "components/Content";
import Form from "components/Form";
import Label from "components/Label";
import Media from "components/Media";
import useAsync from "hooks/use-async";
import React, { FC } from "react";
import toast from "react-hot-toast";
import { formatErrors } from "utils/form";

import styles from "./styles.module.scss";

type FormValues = {
  firstname: string;
  lastname: string;
  phone?: string;
  email: string;
  message?: string;
};

const ContactForm: FC = () => {
  const [submit, submitting] = useAsync(async (values: FormValues) => {
    try {
      await axios.post(
        `https://api.hsforms.com/submissions/v3/integration/submit/20608861/61db0c45-ece8-46ed-81a4-721e2af9e077`,
        {
          fields: Object.keys(values).map((key) => ({
            name: key,
            value: values[key as keyof FormValues]
          }))
        }
      );
      toast.success("We got your information!");
    } catch (e) {
      toast.error("Something went wrong, please try again later");
    }
  });

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <div className={styles.left}>
        <Label className={styles.title} variant="h1" color="primary">
          Contact us
        </Label>
        <Label
          variant="s2"
          color="primary"
          className={styles.paragraph}
          useMarkdown
        >
          {
            "Have any questions? Submit your questions by filling out the form or email us at [hello@humminghomes.com](mailto:hello@humminghomes.com) and we’ll get back to you as soon as possible.\n\n\nIf you are a service provider, please submit your message [here]()."
          }
        </Label>
      </div>
      <Media at={["desktop"]} className={styles.right}>
        <Form
          onError={(errors) =>
            toast.error(formatErrors(errors), { position: "top-right" })
          }
          onSubmit={submit}
          fields={[
            [
              { type: "text", placeholder: "First name", id: "firstname" },
              { type: "text", placeholder: "Last name", id: "lastname" }
            ],
            [
              {
                type: "text",
                placeholder: "Email address",
                id: "email"
              },
              {
                type: "text",
                placeholder: "Phone number",
                id: "phone"
              }
            ],
            {
              placeholder: "Your message",
              type: "area",
              id: "message"
            }
          ]}
        >
          {({ invalid }) => (
            <Button
              type="submit"
              disabled={invalid}
              loading={submitting}
              className={styles.submit}
              variant="accent"
            >
              Send
            </Button>
          )}
        </Form>
      </Media>
      <Media at={["responsive"]} className={styles.right}>
        <Form
          onError={(errors) =>
            toast.error(formatErrors(errors), { position: "top-right" })
          }
          onSubmit={submit}
          fields={[
            { type: "text", placeholder: "First name", id: "firstname" },
            { type: "text", placeholder: "Last name", id: "lastname" },
            {
              type: "text",
              placeholder: "Email address",
              id: "email"
            },
            {
              type: "text",
              placeholder: "Phone number",
              id: "phone"
            },
            {
              placeholder: "Your message",
              type: "area",
              id: "message"
            }
          ]}
        >
          {({ invalid }) => (
            <Button
              type="submit"
              disabled={invalid}
              loading={submitting}
              className={styles.submit}
              variant="accent"
            >
              Send
            </Button>
          )}
        </Form>
      </Media>
    </Content>
  );
};

export default ContactForm;
